import { AfterViewInit, ChangeDetectorRef, Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { OrderHeaderComponent } from './order-header/order-header.component';
import { OrderCountDetailComponent } from './order-count-detail/order-count-detail.component';
import { StepBreadcrumbComponent, StepBreadcrumbItem } from '../../shared/components/step-breadcrumb/step-breadcrumb.component';
import { PoLoadingModule, PoPageModule, PoTooltipModule } from '@po-ui/ng-components';
import { ToasterComponent } from '../../shared/components/toaster/toaster.component';
import { OrderCountStepEnum } from '../../enums/order-count-step.enum';
import { OrderCountHeaderComponent } from './order-count-header/order-count-header.component';
import { CommonModule } from '@angular/common';
import { ModalTerminalSelectComponent } from '../../modal-terminal-select/modal-terminal-select.component';
import { UserTerminalService } from '../../shared/service/user-terminal.service';
import { Router } from '@angular/router';
import { OrderModel } from '../../models/order.model';
import { OrderCountModel } from '../../models/order-count.model';

@Component({
  selector: 'app-order-count',
  imports: [
    CommonModule,
    OrderHeaderComponent,
    ModalTerminalSelectComponent,
    OrderCountHeaderComponent,
    OrderCountDetailComponent,
    StepBreadcrumbComponent,
    PoLoadingModule,
    PoTooltipModule,
    ToasterComponent,
    PoPageModule],
  templateUrl: './order-count.component.html',
  styleUrl: './order-count.component.css'
})
export class OrderCountComponent implements OnInit, AfterViewInit {
  @ViewChild('modalTerminal', { static: false }) modalTerminal!: ModalTerminalSelectComponent;
  @ViewChild('orderHeaderComponent', { static: false }) orderHeaderComponent!: OrderHeaderComponent;
  orderCountStep = 0;
  orderModel!: OrderModel | null;
  orderCountModel!: OrderCountModel | null;
  OrderCountStepEnum = OrderCountStepEnum;
  isLoading = false;
  terminal: string = '';
  size = 'sm';
  text = 'Carregando';
  public readonly breadcrumbs: StepBreadcrumbItem[] = [
    { label: 'Contagem' },
    { label: 'Picking de pedido' }
  ];

  constructor(private cdRef: ChangeDetectorRef,
    private userTerminalService: UserTerminalService,
    private router: Router) { }

  ngOnInit(): void {
    history.pushState(null, '', location.href);
  }


  ngAfterViewInit(): void {
    var userTerminal = this.userTerminalService.getByLoggedUser();

    if (userTerminal == null) {
      this.onTerminalModalOpen();
      return;
    }

    this.terminal = String(userTerminal!.TerminalCode);
    if (this.orderHeaderComponent) {
      this.orderHeaderComponent.getOrders();
    }

    this.cdRef.detectChanges();
  }

  onTerminalModalOpen() {
    this.modalTerminal.open();
    this.cdRef.detectChanges();
  }

  onTerminalSelected(selected: string) {
    this.terminal = selected;
    this.resetSteps();
    this.orderHeaderComponent.getOrders();
  }

  resetSteps() {
    this.orderModel = null;
    this.orderCountModel = null;
    this.orderCountStep = undefined!;
    setTimeout(() => { this.orderCountStep = OrderCountStepEnum.OrderHeader; }, 1000);
  }

  terminalModalClosed() {
    this.router.navigate(['/home']);
  }

  @HostListener('window:popstate', ['$event'])
  onPopState(event: any) {
    if (this.canExit()) {
      history.back();
    } else {
      history.pushState(null, '', location.href);
    }
  }

  canExit(): boolean {
    switch (this.orderCountStep) {
      case OrderCountStepEnum.OrderHeader:
        return true;

      case OrderCountStepEnum.OrderCount:
        this.orderCountStep = OrderCountStepEnum.OrderHeader;
        return false;

      case OrderCountStepEnum.OrderCountDetail:
        this.orderCountStep = OrderCountStepEnum.OrderCount;
        return false;

      default:
        return true;
    }
  }

  navigateBreadcrumb({ item, index }: { item: StepBreadcrumbItem; index: number }) {
    this.orderCountStep = index;
  }

  onOrderHeaderSelected(item: OrderModel) {
    this.orderModel = item;

    this.nextStep();
  }

  onOrderCountSelected(item: any) {
    this.orderCountModel = item;

    this.nextStep();
  }

  nextStep() {
    switch (this.orderCountStep) {
      case OrderCountStepEnum.OrderHeader:
        this.orderCountStep = OrderCountStepEnum.OrderCount;
        break;

      case OrderCountStepEnum.OrderCount:
        this.orderCountStep = OrderCountStepEnum.OrderCountDetail;
        break;

      default:
        this.orderCountStep = OrderCountStepEnum.OrderHeader;
    }
  }
  onLoadingChange(isLoading: boolean) {
    this.isLoading = isLoading;
    this.cdRef.detectChanges();
  }

  onOrderCountFinished() {
    this.orderCountStep = OrderCountStepEnum.OrderCount;
    this.orderCountModel = null;
  }
}
